/**
 * A marca d'água (`A-09`, ADR-060): o e-mail de quem está vendo e a hora, em diagonal, por
 * cima da tela inteira — imagens de pista, modais e o painel do agente incluídos.
 *
 * Ela não impede a cópia; nada na tela impede. Ela **assina** a cópia: um print vazado diz
 * quem e quando. Liga por organização, pelo dono do banco (`marca_dagua`), e não se desliga
 * pela tela. Não recebe clique (`pointer-events: none`) e não é lida por leitor de tela.
 */
import { useEffect, useState } from "react";

import { ladrilhoDaMarca, textoDaMarca } from "../acesso";

export function MarcaDagua({ email }: { email: string }) {
  // O relógio do navegador, de propósito, e não o da demonstração: a hora é a do print.
  const [agora, definirAgora] = useState(() => new Date());
  useEffect(() => {
    const id = window.setInterval(() => definirAgora(new Date()), 30_000);
    return () => window.clearInterval(id);
  }, []);
  const texto = textoDaMarca(email, agora);
  const { imagem } = ladrilhoDaMarca(texto);
  return (
    <div
      aria-hidden="true"
      data-testid="marca-dagua"
      data-texto={texto}
      className="pointer-events-none fixed inset-0 z-[60] select-none"
      style={{ backgroundImage: imagem }}
    />
  );
}
